// Every string a member reads lives here, as a code with its English (D6). Turkish comes as tr.ts
// with the same codes. `{name}` marks a variable that t() fills in. Never put English in a screen.
// A3's words are the owner's, as approved on 2026-10-16 (D22); A5's, the Members tab's, as
// approved on 2026-10-17 (D25); A6's, the Profile tab's, as approved on 2026-10-17 (D26); B3's,
// the Events tab's and the dates', as approved on 2026-10-18 (D34).
export const en = {
  'app.name': 'G Running Club',
  'app.short': 'GRC',
  // Read by screen readers while the app asks the server who is logged in; shown while a list loads.
  'app.loading': 'Loading…',
  'app.retry': 'Try again',
  'app.cancel': 'Cancel',

  // The login screen (its heading is app.name).
  'login.intro': 'Log in with the username and password the club gave you.',
  'login.username': 'Username',
  'login.password': 'Password',
  'login.submit': 'Log in',
  'login.submitting': 'Logging in…',
  'login.noAccount': "No account yet? Ask the club's admin for one.",
  'login.loggedOut': "You've been logged out. Log in again.",

  // The forced password change, after a one-time password.
  'password.title': 'Choose your password',
  'password.intro': 'You logged in with a one-time password. Choose your own to continue.',
  'password.current': 'Current password',
  'password.new': 'New password',
  'password.newHint': 'At least 8 characters.',
  'password.repeat': 'New password again',
  'password.submit': 'Save password',
  'password.submitting': 'Saving…',

  // The shell: the top bar, and the tabs (a phone) or the side nav (a desktop).
  'shell.logout': 'Log out',
  'nav.label': 'Main menu',
  'nav.home': 'Home',
  'nav.events': 'Events',
  'nav.boards': 'Boards',
  'nav.profile': 'Profile',
  'nav.members': 'Members',
  // A tab whose screen a later step builds (its heading is the tab's name).
  'soon.text': 'Coming soon',

  // Home, until B5's announcement and events.
  'home.welcome': 'Welcome, {name}.',
  'home.tagline': "The members' app of G Running Club.",

  // Dates and times, on the club's clock (Asia/Nicosia) whatever the phone's zone, on every events
  // screen: the patterns, then the days' and the months' names. Times are the 24-hour clock's.
  'date.long': '{weekday} {day} {month}',
  // A date in another year than the club's today.
  'date.longYear': '{weekday} {day} {month} {year}',
  'date.monthYear': '{month} {year}',
  'date.timeRange': '{start}–{end}',
  'date.timeRangeNextDay': '{start}–{end} the next day',
  // A day's heading in the lists, {date} being date.long.
  'date.today': 'Today, {date}',
  'date.tomorrow': 'Tomorrow, {date}',
  'date.yesterday': 'Yesterday, {date}',
  'date.monday': 'Monday',
  'date.tuesday': 'Tuesday',
  'date.wednesday': 'Wednesday',
  'date.thursday': 'Thursday',
  'date.friday': 'Friday',
  'date.saturday': 'Saturday',
  'date.sunday': 'Sunday',
  // The month view's columns.
  'date.mon': 'Mon',
  'date.tue': 'Tue',
  'date.wed': 'Wed',
  'date.thu': 'Thu',
  'date.fri': 'Fri',
  'date.sat': 'Sat',
  'date.sun': 'Sun',
  'date.january': 'January',
  'date.february': 'February',
  'date.march': 'March',
  'date.april': 'April',
  'date.may': 'May',
  'date.june': 'June',
  'date.july': 'July',
  'date.august': 'August',
  'date.september': 'September',
  'date.october': 'October',
  'date.november': 'November',
  'date.december': 'December',

  // The Events tab (its heading is nav.events): the switch between its views, and the lists.
  // Read by screen readers: the switch's name.
  'events.views': 'Event views',
  'events.upcoming': 'Upcoming',
  'events.past': 'Past',
  'events.month': 'Month',
  'events.none': 'No events coming up.',
  'events.noPast': 'No past events yet.',
  'events.older': 'Show older events',
  'events.typePlace': '{type} · {place}',
  'events.counts': '{yes} yes, {maybe} maybe',
  'events.cancelled': 'Cancelled',
  // The member's own answer, on an event's row.
  'events.saidYes': 'You said yes',
  'events.saidMaybe': 'You said maybe',
  'events.saidNo': 'You said no',
  // An event's type.
  'event.training': 'Training',
  'event.race': 'Race',
  'event.social': 'Social',

  // The month view.
  'month.previous': 'Previous month',
  'month.next': 'Next month',
  // Read by screen readers: a day of the grid, {date} being date.long.
  'month.dayEvents': '{date}: {count} events',
  'month.dayEventsOne': '{date}: 1 event',
  'month.noEvents': 'No events on this day.',
  'month.none': 'No events this month.',
  // Under the grid of a month that reaches past the eight weeks a series' events are made for.
  'month.ahead': 'Weekly events show up to eight weeks ahead.',

  // An event's page (its heading is the event's title).
  'event.back': 'All events',
  'event.cancelledNote': 'This event is cancelled.',
  'event.when': 'When',
  'event.where': 'Where',
  'event.notes': 'Notes',
  'event.map': 'Open the map',
  'event.question': 'Are you coming?',
  'event.yes': 'Yes',
  'event.maybe': 'Maybe',
  'event.no': 'No',
  'event.saving': 'Saving…',
  'event.over': 'This event is over.',
  'event.who': "Who's coming",
  'event.yesCount': 'Yes ({count})',
  'event.maybeCount': 'Maybe ({count})',
  'event.nobody': 'Nobody yet.',
  'event.gone': 'This event has been removed.',

  // The Profile tab (its heading is nav.profile): who the member is, and the way to the password.
  'profile.displayName': 'Display name',
  'profile.username': 'Username',
  // A member asks an admin to change them (D26); an admin gets a link to their own page instead.
  'profile.askAdmin': "Ask the club's admin to change your name or username.",
  'profile.editInMembers': 'Change your name or username in Members',
  'profile.changePassword': 'Change password',
  // Said on Profile once the change of password is saved.
  'profile.passwordChanged': 'Password changed.',

  // Settings, on the Profile tab: the rows to come, shown and off.
  'settings.title': 'Settings',
  'settings.language': 'Language',
  'settings.english': 'English',
  'settings.languageNote': 'Turkish comes later.',
  'settings.notifications': 'Notifications',
  'settings.notificationsNote': 'Coming soon, in the app: new events, changes and reminders.',

  // A member's own change of password, from Profile (its fields and its button are password.*).
  'profilePassword.title': 'Change password',
  'profilePassword.intro':
    "You'll stay logged in here, and your other phones and computers will need the new password.",

  // The Members tab, an admin's (its heading is nav.members): the list and its search.
  'members.add': 'Add a member',
  'members.search': 'Search by name or username',
  'members.count': '{count} members',
  'members.countOne': '1 member',
  'members.noMatch': 'No member matches “{query}”.',
  'members.tagYou': 'You',
  'members.tagAdmin': 'Admin',
  'members.tagDisabled': 'Disabled',
  'members.tagOneTime': 'One-time password',
  'members.removed': '{name} was removed.',

  // Adding a member.
  'newMember.title': 'Add a member',
  'newMember.intro':
    "You'll see their one-time password once. They log in with it and choose their own.",
  'newMember.submit': 'Add member',
  'newMember.submitting': 'Adding…',

  // A member's fields, when adding them and on their page.
  'member.displayName': 'Display name',
  'member.displayNameHint': 'The name the other members see.',
  'member.username': 'Username',
  'member.usernameHint':
    'What they log in with: 3 to 32 of a–z, 0–9, dots, hyphens and underscores.',
  'member.role': 'Role',
  'member.roleMember': 'Member',
  'member.roleAdmin': 'Admin',

  // A member's page: the edit, and what an admin can do to the account.
  'member.back': 'All members',
  'member.save': 'Save changes',
  'member.saving': 'Saving…',
  'member.saved': 'Saved.',
  'member.disable': 'Disable account',
  'member.disabling': 'Disabling…',
  'member.disabledNote':
    "Account disabled. They're logged out and can't log in until you enable it.",
  'member.enable': 'Enable account',
  'member.enabling': 'Enabling…',
  'member.enabledNote': 'Account enabled. They can log in again.',
  'member.reset': 'Reset password',
  'member.resetConfirm':
    "Reset {name}'s password? They're logged out everywhere and need the new one-time password to log in.",
  'member.resetYes': 'Yes, reset',
  'member.resetting': 'Resetting…',
  'member.remove': 'Remove member',
  'member.removeConfirm': "Remove {name} and everything of theirs? This can't be undone.",
  'member.removeYes': 'Yes, remove',
  'member.removing': 'Removing…',
  'member.own':
    'This is your account. Another admin can change your role, reset your password, or disable or remove it.',
  // Under that line: where an admin changes their own password (A6; D26).
  'member.ownPassword': 'Change your password in Profile',
  'member.gone': "This member isn't in the club any more.",

  // A one-time password, shown once: after adding a member, and after a reset.
  'oneTime.addedTitle': 'Member added',
  'oneTime.resetTitle': 'Password reset',
  'oneTime.give': 'Give {name} their username and this one-time password.',
  'oneTime.password': 'One-time password',
  'oneTime.once':
    "It's shown only this once. If it gets lost, reset the password to make a new one.",
  'oneTime.copy': 'Copy message',
  // What Copy message puts on the clipboard, to paste into a chat with the member.
  'oneTime.message':
    'Your G Running Club login: username {username}, one-time password {password}. Log in at {address} and choose your own password.',
  'oneTime.copied': 'Copied.',
  'oneTime.copyFailed': "Couldn't copy. Select the password and copy it.",
  'oneTime.done': 'Done',

  // The error line under a form (errors.ts turns each code into one of these).
  'error.credentials': 'Wrong username or password.',
  'error.disabled': "This account is disabled. Ask the club's admin.",
  'error.lockedMinutes': 'Too many tries. Try again in {minutes} minutes.',
  'error.lockedMinute': 'Too many tries. Try again in a minute.',
  'error.wrongPassword': "That's not your current password.",
  'error.passwordRule': 'The new password needs at least 8 characters.',
  'error.samePassword': 'Choose a password different from your current one.',
  'error.mismatch': "The two new passwords don't match.",
  'error.usernameRule':
    "That username won't work: use 3 to 32 of a–z, 0–9, dots, hyphens and underscores, starting and ending with a letter or a digit.",
  'error.forbidden': "Only the club's admins can do that.",
  'error.usernameTaken': 'Another member has that username. Choose another one.',
  'error.ownAccount': "You can't do that to your own account. Another admin can.",
  'error.lastAdmin': "The club needs at least one active admin, so that can't be done.",
  // An answer the event no longer takes (B3); the first also under the buttons of an event under way.
  'error.eventStarted': 'This event has started, so answers are closed.',
  'error.eventCancelled': 'This event has been cancelled, so answers are closed.',
  'error.network': "Can't reach the server. Check your connection and try again.",
  'error.server': 'Something went wrong. Try again in a moment.',
} as const;

export type Code = keyof typeof en;
